import Icon from 'components/Icon';
import TooltipWrapper from 'components/Tooltip';
import {useTooltip} from 'components/Tooltip/hook';
import {ComponentProps, FC} from 'react';
import {t} from 'ttag';
import {jstDateString} from 'utils/date';

const IconWithTooltip: FC<ComponentProps<typeof Icon>> = (props) => {
    const {setTooltipRef} = useTooltip();

    return <Icon ref={setTooltipRef} {...props} />;
};

type SupersendDocumentIconsProps = {
    datePaid?: string;
    dateSent?: string;
    dateSentByPost?: string;
    dateViewed?: string;
    shouldDisplayNotViewed?: boolean;
    shouldDisplayNotYetSendbypost?: boolean;
};

const SupersendDocumentIcons: FC<SupersendDocumentIconsProps> = ({
    datePaid,
    dateSent,
    dateSentByPost,
    dateViewed,
    shouldDisplayNotViewed,
    shouldDisplayNotYetSendbypost,
}) => {
    const jstDatePaid = datePaid ? jstDateString(datePaid) : datePaid;
    const jstDateSent = dateSent ? jstDateString(dateSent) : dateSent;
    const jstDateSentByPost = dateSentByPost
        ? jstDateString(dateSentByPost)
        : dateSentByPost;
    const jstDateViewed = dateViewed ? jstDateString(dateViewed) : dateViewed;

    return (
        <>
            {jstDatePaid && (
                <TooltipWrapper message={t`Paid: ${jstDatePaid}`}>
                    <IconWithTooltip
                        aria-label={t`Date Paid`}
                        icon="enabled_checkbox"
                        id="datePaid"
                        role="tooltip"
                        size="base"
                    />
                </TooltipWrapper>
            )}
            {jstDateSent && (
                <TooltipWrapper message={t`Sent: ${jstDateSent}`}>
                    <IconWithTooltip
                        aria-label={t`Date Sent`}
                        icon="send_complete"
                        id="dateSent"
                        role="tooltip"
                        size="base"
                    />
                </TooltipWrapper>
            )}
            {jstDateViewed && (
                <TooltipWrapper message={t`Viewed: ${jstDateViewed}`}>
                    <IconWithTooltip
                        aria-label={t`Date Viewed`}
                        icon="show"
                        id="dateViewed"
                        role="tooltip"
                        size="base"
                    />
                </TooltipWrapper>
            )}
            {shouldDisplayNotViewed && (
                <TooltipWrapper message={t`Not Viewed`}>
                    <IconWithTooltip icon="hide" id="notViewed" size="base" />
                </TooltipWrapper>
            )}
            {jstDateSentByPost && (
                <TooltipWrapper
                    message={t`Sent by Japan Post: ${jstDateSentByPost}`}
                >
                    <IconWithTooltip
                        aria-label={t`Date Sent by Japan Post`}
                        icon="mail_point"
                        id="dateSentByPost"
                        role="tooltip"
                        size="base"
                    />
                </TooltipWrapper>
            )}
            {shouldDisplayNotYetSendbypost && (
                <TooltipWrapper message={t`Not Yet Sent`}>
                    <IconWithTooltip
                        icon="mail_point"
                        id="notYetSendByPost"
                        size="base"
                    />
                </TooltipWrapper>
            )}
        </>
    );
};

export default SupersendDocumentIcons;
